import React, { useState, useEffect } from 'react';
import { useApp } from "../components/AppContext";
import { MainLayout } from "../components/MainLayout";
import { useTranslation } from "../i18n/TranslationContext";

export function AppSettings() {
	const { navigateDirectly } = useApp();
	const { t } = useTranslation();


	const settingsOptions = [
		{
			id: "help-support",
			title: t("appSettings.sections.help"),
			description: t("appSettings.help.userGuide"),
			icon: "❓",
			screen: "app-info-faq" as const,
		},
		{
			id: "delete-account",
			title: "Account löschen",
			description: "Ihren Account und alle zugehörigen Daten permanent löschen",
			icon: "🗑️",
			screen: "delete-my-account" as const,
		},
		// {
		// 	id: "account",
		// 	title: t("appSettings.sections.account"),
		// 	description: t("appSettings.account.changePassword"),
		// 	icon: "👤",
		// 	screen: null,
		// },
		// {
		//   id: 'notifications',
		//   title: t('appSettings.sections.notifications'),
		//   description: t('appSettings.notifications.emailNotifications'),
		//   icon: '🔔',
		//   screen: null
		// },
		// {
		// 	id: "privacy",
		// 	title: t("appSettings.sections.privacy"),
		// 	description: t("appSettings.privacy.privacyPolicy"),
		// 	icon: "🔒",
		// 	screen: null,
		// },
	];

	const allOptions = settingsOptions;

	const handleOptionClick = (option: any) => {
		if (option.screen) {
			navigateDirectly(option.screen);
		} else {
			// For future implementation
			console.log(`${option.title} geklickt - Demnächst verfügbar`);
		}
	};

	return (
		<MainLayout showBack={true} onBack={() => navigateDirectly("dashboard")}>
			<div className="flex flex-col h-full">
				{/* Header */}
				<div className="bg-gradient-to-b px-4 mb-6">
					<h1 className="text-2xl font-bold text-[var(--ucm-text-dark)]">
						{t("appSettings.title")}
					</h1>
				</div>

				{/* Settings Options */}
				<div className="px-4 space-y-3 pb-6">
					{allOptions.map((option) => (
						<button
							key={option.id}
							onClick={() => handleOptionClick(option)}
							className="w-full bg-white rounded-2xl p-4 shadow-[0_4px_16px_rgba(0,0,0,0.08)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.12)] transition-all duration-200 text-left"
						>
							<div className="flex items-center space-x-4">
								{/* Option Details */}
								<div className="flex-1">
									<h3 className="font-semibold text-[var(--ucm-text-dark)] mb-1">
										{option.title}
									</h3>
									<p className="text-sm text-[var(--ucm-text-medium)]">
										{option.description}
									</p>
									{!option.screen && (
										<p className="text-xs text-[var(--ucm-text-light)] mt-1">
											Demnächst verfügbar...
										</p>
									)}
								</div>

								{/* Arrow */}
								<div className="flex-shrink-0">
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										className="text-[var(--ucm-text-light)]"
									>
										<path
											d="M6 12L10 8L6 4"
											stroke="currentColor"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</div>
							</div>
						</button>
					))}
				</div>
			</div>
		</MainLayout>
	);
}
